import $ from 'jquery';

// Import specific modules instead of bundled versions
import Masonry from 'masonry-layout/masonry';
import imagesLoaded from 'imagesloaded';

/* ===============================================================
Masonry Init - Optimized for Speed
=============================================================== */
class MasonryJs {
    constructor() {
        // Wait for DOM and images to be ready
        $(window).on('load', () => this.init());
    }

    init() {
        this.initAllMasonryGrids();
        this.setupResizeHandler();
    }

    setupResizeHandler() {
        // Debounced resize handler
        let resizeTimeout;
        $(window).on('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                this.initAllMasonryGrids();
                this.videoItemInMasonryResize();
            }, 150);
        });
    }

    initAllMasonryGrids() {
        // Initialize all masonry grids in one pass
        this.initMasonryGrid('.irantheme-grid-masonry', {
            itemSelector: '.irantheme-grid-masonry-item',
            columnWidth: '.irantheme-grid-masonry-sizer',
            gutter: '.irantheme-grid-masonry-gutter-sizer',
        });

        this.initMasonryGrid('.irantheme-grid-masonry-layout', {
            itemSelector: '.irantheme-grid-masonry-layout-item',
            columnWidth: '.irantheme-grid-masonry-layout-sizer',
        });

        this.initMasonryGrid('.irantheme-blog-post-masonry', {
            itemSelector: '.irantheme-blog-post-masonry-item',
            columnWidth: '.irantheme-blog-post-masonry-sizer',
            gutter: '.irantheme-blog-post-masonry-gutter-sizer',
        });

        this.initMasonryGrid('.irantheme-grid-masonry-cart-navigation', {
            itemSelector: '.irantheme-grid-masonry-cart-navigation-item',
            columnWidth: '.irantheme-grid-masonry-cart-navigation-sizer',
            gutter: 10,
        });
    }

    initMasonryGrid(selector, options) {
        const $grid = $(selector);

        if (!$grid.length) return;

        // Default options
        const defaultOptions = {
            percentPosition: true,
            originLeft: false,
            transitionDuration: '0.3s', // Reduced for speed
            stagger: 30,
            resize: false, // Disable auto-resize for performance
        };

        // Merge options
        const mergedOptions = { ...defaultOptions, ...options };

        // Initialize masonry after images are loaded
        imagesLoaded($grid[0], () => {
            new Masonry($grid[0], mergedOptions);
        });
    }

    // Optimized video resize function
    videoItemInMasonryResize() {
        $(
            '.irantheme-media-gallery-masonry .irantheme-media-gallery-item .irantheme-media-gallery-item-video',
        ).each((index, element) => {
            const $element = $(element);
            const $parent = $element.closest('.irantheme-media-gallery-item');
            const height = $parent.height();

            $element.parent().height(height);
            $element.height(height);
        });
    }
}

export default MasonryJs;
